import Nav from '../nav/Nav';
import Main_Content from '../main_content/Main_Content';
import {connect} from "react-redux";
import { getCustomize,getUser } from "../../redux/actions/actions.js";
import Right from '../right/Right';
import { useEffect,useContext } from "react";
import jwt_decode from "jwt-decode";
import { AppContext } from "../../App";
import { useNavigate } from "react-router-dom";
import '../../App.css';
import Dialog_CreateTweet from './Dialog_CreateTweet';
import Dialog_Customize from './Dialog_Customize';

function Main(props) {
    const {accessToken} = useContext(AppContext);
    const navigate = useNavigate();
    useEffect(() => {
        try {
            const decode = jwt_decode(accessToken);
            const expire = decode.exp;
            if (expire * 1000 < new Date().getTime()) {
                navigate("/start/signin");
            };
            props.onGetCustomize(decode.userId);
            props.onGetUser(decode.userId);
        } catch (error) {
            navigate("/start/signin");
        }
    },[])
    return (
        <div className={`main main_${props.color_background} main_size_${props.font_size}`}>
            <Nav />
            <Main_Content />
            <Right />
            <Dialog_CreateTweet />
            <Dialog_Customize />
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        color_background: state.getColorBackground.color_background,
        font_size: state.getFontSize.font_size,
        color_button: state.getColorButton.color_button,
        user: state.getUser.user
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        onGetCustomize: (id) => dispatch(getCustomize(id)),
        onGetUser: (id) => dispatch(getUser(id))
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(Main);